import Vue from 'vue'
import App from './App.vue';
import AppMobile from './AppMobile.vue';
import VueResource from 'vue-resource';

Vue.config.productionTip = false

Vue.use(VueResource);

new Vue({
  render: h => h(App),
})
.$mount('#b2b-sent-request-form');

new Vue({
  render: h => h(AppMobile),
})
.$mount('#b2b-sent-request-form-mobile');
